import { createStore, select, withProps } from '@ngneat/elf';
import { filter, map } from 'rxjs';

export type VidyardHelpVideo =
  | 'adding-users-and-vehicles'
  | 'ams-getting-started'
  | 'configure-fleet-settings-overview'
  | 'create-and-assign-configuration-profiles'
  | 'create-and-assign-map-sets'
  | 'create-and-assign-vehicle-routing-profiles'
  | 'creating-vehicle-groups'
  | 'migrating-to-ams-from-fp';

interface VidyardVideoSource {
  dataUUID: string;
}

const VIDYARD_HELP_VIDEO_SOURCES = new Map<
  VidyardHelpVideo,
  VidyardVideoSource
>([
  [
    'adding-users-and-vehicles',
    {
      dataUUID: 'qEPJssib2YnTFJd1GLVPn9',
    },
  ],
  [
    'ams-getting-started',
    {
      dataUUID: 'MbA5mQeyh3jaQEpro2JCTR',
    },
  ],
  [
    'configure-fleet-settings-overview',
    {
      dataUUID: 'sUthLUV74rXj8ApUEzu6PK',
    },
  ],
  [
    'create-and-assign-configuration-profiles',
    {
      dataUUID: 'XCGUoE4sdAdS9uTcd5tiPd',
    },
  ],
  [
    'create-and-assign-map-sets',
    {
      dataUUID: 'Sviw3U3EqqTfWXybUsRgT2',
    },
  ],
  [
    'create-and-assign-vehicle-routing-profiles',
    {
      dataUUID: 'j7UjimevEpqQtrhi1bYzQa',
    },
  ],
  [
    'creating-vehicle-groups',
    {
      dataUUID: 'jbqFRwevc24D44SjLF4ety',
    },
  ],
  [
    'migrating-to-ams-from-fp',
    {
      dataUUID: 'ALEVEdZ2K1G3StReps8AeJ',
    },
  ],
]);

interface VidyardProps {
  currentVideo: VidyardHelpVideo;
}

const vidyardStore = createStore(
  { name: 'vidyard' },
  withProps<VidyardProps>({
    currentVideo: 'adding-users-and-vehicles',
  })
);

/** Snapshots */

export const currentVidyardUUID = () =>
  VIDYARD_HELP_VIDEO_SOURCES.get(vidyardStore.getValue().currentVideo)
    ?.dataUUID;

/** Exposed Variables and Observables */

export const currentVideoUUID$ = vidyardStore.pipe(
  select(({ currentVideo }) => currentVideo),
  map((currentVideo) => VIDYARD_HELP_VIDEO_SOURCES.get(currentVideo)),
  filter(
    (source): source is VidyardVideoSource => typeof source !== 'undefined'
  ),
  map(({ dataUUID }) => dataUUID)
);

/** Updater Functions */

export function updateCurrentVideo(currentVideo: VidyardHelpVideo) {
  vidyardStore.update((state) => ({
    ...state,
    currentVideo,
  }));
}

export function resetVidyardStore() {
  vidyardStore.reset();
}
